import React from 'react';
// import { useMediaContext } from 'saladsoft-primitive';
import styled from 'styled-components';
const PageContainer = ({
  style,
  header,
  className,
  children,
}: {
  style?: React.CSSProperties;
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => {
  // const { isSmall, isMedium, isLarge, isXLarge, isMobile, isTablet, isDesktop } = useMediaContext();
  return (
    <Container style={style} className={className}>
      {header && <HeaderContainer>{header}</HeaderContainer>}
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  background: #fff;
  margin: 0 auto;
  flex-direction: column;
  @media ${(props) => props.theme.media.mobile} {
  }
`;


const ContentContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  > div {
    /* max-width: 1200px; */
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
`;

export default PageContainer;
